var map = {
	"./bg/core": [
		7131,
		131
	],
	"./cs/core": [
		2666,
		666
	],
	"./da/core": [
		5279,
		279
	],
	"./de/core": [
		5078,
		78
	],
	"./en/core": [
		7229
	],
	"./es/core": [
		7546,
		546
	],
	"./fr/core": [
		249,
		249
	],
	"./hu/core": [
		1256,
		875
	],
	"./id/core": [
		2559,
		559
	],
	"./it/core": [
		7215,
		215
	],
	"./ja/core": [
		3503,
		503
	],
	"./ko/core": [
		4896,
		896
	],
	"./nl/core": [
		2998,
		998
	],
	"./pl/core": [
		7711,
		711
	],
	"./pt/core": [
		3209,
		590
	],
	"./ro/core": [
		9200,
		200
	],
	"./ru/core": [
		4210,
		210
	],
	"./sk/core": [
		1775,
		156
	],
	"./sv/core": [
		2583,
		583
	],
	"./tr/core": [
		2631,
		631
	],
	"./ua/core": [
		1518,
		518
	],
	"./uz/core": [
		1905,
		905
	],
	"./zh/core": [
		5222,
		222
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;